/**
 * Client navigation config for the C1 top-nav shell.
 * Primary tabs live in the header; Messages is the mail action;
 * Profile / Guides / Settings live in the account menu.
 */

export const PRIMARY_TABS = Object.freeze([
  { id: 'home', label: 'Home', to: '/client/home' },
  { id: 'demands', label: 'Demands', to: '/client/demands' },
  { id: 'debtors', label: 'Debtors', to: '/client/debtors' },
  { id: 'payments', label: 'Payments', to: '/client/payments' },
  { id: 'evidence-locker', label: 'Evidence', to: '/client/evidence-locker' },
  { id: 'reports', label: 'Reports', to: '/client/reports' },
]);

export const ACCOUNT_NAV = Object.freeze([
  { id: 'profile', label: 'Profile', to: '/client/settings?tab=profile' },
  { id: 'guides', label: 'Guides', to: '/client/guides' },
  { id: 'settings', label: 'Settings', to: '/client/settings?tab=billing' },
]);

/** Full app destinations (mobile menu + active-route resolution). */
const NAV = Object.freeze([
  ...PRIMARY_TABS,
  { id: 'messages', label: 'Messages', to: '/client/messages' },
  ...ACCOUNT_NAV,
]);

export function settingsTabFromSearch(search = '') {
  const raw = String(search || '').startsWith('?')
    ? new URLSearchParams(search).get('tab')
    : new URLSearchParams(String(search || '')).get('tab');
  return raw === 'connections' ? 'integrations' : raw || '';
}

export function isClientSettingsPath(pathname = '') {
  return (
    String(pathname || '').startsWith('/client/settings') ||
    String(pathname || '').startsWith('/settings')
  );
}

export function getActiveNav(pathname, search = '') {
  const settingsTab = settingsTabFromSearch(search);
  const active =
    NAV.find((item) => {
      if (item.id === 'profile') {
        return isClientSettingsPath(pathname) && settingsTab === 'profile';
      }
      if (item.id === 'settings') {
        return isClientSettingsPath(pathname) && settingsTab !== 'profile';
      }
      if (item.id === 'demands') return pathname.startsWith('/client/demands');
      if (item.id === 'debtors') return pathname.startsWith('/client/debtors');
      if (item.id === 'payments') return pathname.startsWith('/client/payments');
      if (item.id === 'evidence-locker') return pathname.startsWith('/client/evidence-locker');
      if (item.id === 'reports') return pathname.startsWith('/client/reports');
      if (item.id === 'guides') {
        return (
          pathname.startsWith('/client/guides') || pathname.startsWith('/client/learn')
        );
      }
      if (item.id === 'messages') return pathname.startsWith('/client/messages');
      if (item.id === 'home') {
        return (
          pathname.startsWith('/client/home') || pathname === '/client' || pathname === '/client/'
        );
      }
      return pathname.startsWith(String(item.to).split('?')[0]);
    }) || NAV[0];

  return { active, items: NAV, primaryTabs: PRIMARY_TABS, accountItems: ACCOUNT_NAV };
}

/** @deprecated Sidebar removed in C1 top-nav shell; kept as no-op for any leftover imports. */
export default function ClientSidebar() {
  return null;
}

export { NAV as CLIENT_NAV };
